@if (orders) {
  <p-table
    #dt
    [value]="orders"
    dataKey="uuid"
    [styleClass]="'pansa-table'"
    [scrollable]="true"
    [scrollHeight]="tableHeight"
    [rowExpandMode]="'single'"
    [(selection)]="selectedOrders"
    (onRowSelect)="checkIsSomeFeatureOrderSelected()"
    (onRowUnselect)="checkIsSomeFeatureOrderSelected()"
    [breakpoint]="'960px'"
    (onHeaderCheckboxToggle)="checkIsSomeFeatureOrderSelected()"
    [globalFilterFields]="['designator', 'startDate', 'endDate', 'upperAltitude', 'lowerAltitude', 'activityType']"
    (onFilter)="onTableFiltered()"
  >
    <ng-template pTemplate="caption">
      <div class="flex justify-content-between align-items-center lg:flex-row flex-column">
        <div class="flex items-center">
          <p-checkbox
            inputId="onlyMyOrders"
            [(ngModel)]="onlyMyOrders"
            [binary]="true"
            (onChange)="getSentOrders(onlyMyOrders)"
          />
          <label for="onlyMyOrders" class="ml-2"> {{ 'orders.onlyMyOrders' | translate }} </label>
        </div>
        <div>
          <p-iconfield iconPosition="left" class="p-input-icon-left w-full lg:w-auto">
            <p-inputicon>
              <i class="pi pi-search"></i>
            </p-inputicon>
            <input
              class="w-full"
              pInputText
              type="text"
              (input)="filterReservations($event, 'containsWithDateFormat')"
              [placeholder]="'table.search' | translate"
            />
          </p-iconfield>
        </div>
        <div class="flex align-items-center flex-column lg:flex-row p-2 lg:p-0">
          @if (dateRange.length && orders.length) {
            <div class="lg:p-0 p-2">
              <p-button [label]="'buttons.print' | translate" icon="pi pi-print" (click)="getAupFile()" />
            </div>
          }
          <p-datepicker
            [(ngModel)]="dateRange"
            [dateFormat]="dateFormat"
            [iconDisplay]="'input'"
            [showIcon]="true"
            selectionMode="range"
            [readonlyInput]="true"
            [minDate]="minDate"
            (onSelect)="filterByDate($event)"
            #calendar
            pTooltip="{{ 'tooltips.calendarTooltip' | translate }}"
            [firstDayOfWeek]="1"
            tooltipPosition="top"
          >
            <ng-template pTemplate="footer">
              <div class="flex justify-content-between">
                <p-button
                  [label]="'primeng.clear' | translate"
                  [text]="true"
                  icon="pi pi-times"
                  (click)="clearFilters()"
                ></p-button>
              </div>
            </ng-template>
          </p-datepicker>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr class="text-xs">
        <th style="width: 4rem">
          <p-tableHeaderCheckbox />
        </th>
        <th class="text-xs pl-3 pr-2" pSortableColumn="designator">
          {{ 'table.header.designator' | translate }}
          <p-sortIcon field="designator"></p-sortIcon>
        </th>
        <th class="text-xs pl-1 pr-2" pSortableColumn="startDate">
          {{ 'table.header.startDate' | translate }}
          <p-sortIcon field="startDate"></p-sortIcon>
        </th>
        <th class="text-xs pl-1 pr-2" pSortableColumn="endDate">
          {{ 'table.header.endDate' | translate }}
          <p-sortIcon field="endDate"></p-sortIcon>
        </th>
        <th class="text-xs pl-1 pr-2" pSortableColumn="lowerAltitude">
          {{ 'table.header.lowerAltitude' | translate }}
          <p-sortIcon field="lowerAltitude"></p-sortIcon>
        </th>
        <th class="text-xs pl-1 pr-2" pSortableColumn="upperAltitude">
          {{ 'table.header.upperAltitude' | translate }}
          <p-sortIcon field="upperAltitude"></p-sortIcon>
        </th>
        <th class="text-xs pl-1 pr-2" pSortableColumn="activityType">
          {{ 'table.header.activityType' | translate }}
          <p-sortIcon field="activityType"></p-sortIcon>
        </th>
        <th class="text-xs pl-1 pr-2"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-order let-expanded="expanded">
      <tr class="text-sm">
        <td>
          <p-tableCheckbox [value]="order" />
        </td>
        <td class="p-1 pl-3">{{ order.designator }}</td>
        <td class="p-1">{{ order.startDate | date: 'yyyy-MM-dd HH:mm' }}</td>
        <td class="p-1">{{ order.endDate | date: 'yyyy-MM-dd HH:mm' }}</td>
        <td class="p-1">{{ order.lowerAltitude }}</td>
        <td class="p-1">{{ order.upperAltitude }}</td>
        <td class="p-1">{{ order.activityType }}</td>
        <td>
          <p-button
            type="button"
            pRipple
            (onClick)="op.toggle($event)"
            [text]="true"
            [rounded]="true"
            [plain]="true"
            icon="pi pi-calendar-clock"
          />
          <p-popover #op (onShow)="showOrderHistory(order)" [styleClass]="'w-16rem'">
            <div *ngIf="order.reservationHistory?.length">
              <ul class="m-0 p-0 list-none">
                <li *ngFor="let history of order.reservationHistory">
                  <strong>{{ 'orders.history.' + history.historyEvent | translate }}:</strong>
                  {{ history.eventDate }}
                  <strong>{{ 'orders.history.changedBy' | translate }}:</strong> {{ history.changedBy }}
                </li>
              </ul>
            </div>
          </p-popover>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr>
        <td colspan="8">
          <p-button
            [label]="'buttons.cancel' | translate"
            [disabled]="!selectedOrders.length || !isSomeFutureOrderSelected"
            (click)="onRemoveSelected()"
            [text]="true"
            [plain]="true"
          >
            <rqa-icon iconName="trash" class="p-button-icon-left"></rqa-icon>
          </p-button>
          <p-button
            [label]="'buttons.edit' | translate"
            [disabled]="!selectedOrders.length"
            (click)="onEditSelected()"
            [text]="true"
            [plain]="true"
          >
            <rqa-icon iconName="duplicate" class="p-button-icon-left"></rqa-icon>
          </p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
}
